import React from "react";
import { Card } from "react-bootstrap";
import styles from "../css/payment.module.css";

const moneyFormater = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "PGK"
});

export const SelectedServiceItemDetails = ({item,deptLogo}) => {

  return (
    <Card>
      <Card.Img
        variant="top"
        src={deptLogo}
        style={{width:'25%', marginTop:'1.9rem'}}
            className="mx-auto d-block"

        
      />
      <Card.Body>
        <Card.Title>
          <h4>Selected Service Details</h4>
        </Card.Title>
        <table className={`card-table table-borderless ${styles.selectedServiceTable}`}>
          <tbody>
            <tr>
              <td><strong>Province:</strong></td>
              <td style={{paddingLeft:"10px"}}>{item.prov_name}</td>
            </tr>

            <tr><td colSpan="2">&nbsp;</td></tr>

            <tr>
              <td><strong>Department:</strong></td>
              <td style={{paddingLeft:"10px"}}>{item.dept_name}</td>
            </tr>
            
            <tr><td colSpan="2">&nbsp;</td></tr>

            <tr>
              <td><strong>Service:</strong></td>
              <td style={{paddingLeft:"10px"}}>{item.serv_name}</td>
            </tr>        
            
            <tr><td colSpan="2">&nbsp;</td></tr>
    
            <tr>
              <td><strong>Revenue Code:</strong></td>
              <td style={{paddingLeft:"10px"}}>{item.service_item_number}</td>
            </tr>

            <tr><td colSpan="2">&nbsp;</td></tr>

            <tr>
              <td><strong>Serivce Item:</strong></td>
              <td style={{paddingLeft:"10px"}}>{item.description}</td>
            </tr>

            <tr><td colSpan="2">&nbsp;</td></tr>

            <tr>
              <td><strong>Price:</strong></td>
              <td style={{paddingLeft:"10px"}}>{moneyFormater.format(item.price)}</td>
            </tr>
          </tbody>
        </table>
        {/* 
      <Container fluid>
        <Row>
          <Col lg={12}>
            <Form.Group controlId="selectedProvince">
              <Form.Label>Province</Form.Label>
              <Form.Control
                name="selectedProvince"
                readOnly
                value="NCDC"
                className={styles.selectedServiceControl}
              />
            </Form.Group>
          </Col>
          <Col lg={12}>
            <Form.Group controlId="selectedDepartment">
              <Form.Label>Department</Form.Label>
              <Form.Control
                name="selectedDepartment"
                readOnly
                value="Police Department"
                className={styles.selectedServiceControl}
              />
            </Form.Group>
          </Col>
          <Col lg={12}>
            <Form.Group controlId="selectedServiceControl">
              <Form.Label>Service Type</Form.Label>
              <Form.Control
                name="selectedService"
                readOnly
                value={selectedService? selectedService.value : ""}
                className={styles.selectedServiceControl}
              />
            </Form.Group>
          </Col>
          <Col lg={12}>
            <Form.Group controlId="amountControl">
              <Form.Label>Amount</Form.Label>
              <Form.Control
                name="amount"
                readOnly
                value={selectedService? selectedService.amount : ""}
                className={styles.selectedServiceControl}
              />
            </Form.Group>
          </Col>            
        </Row>
      </Container>
    */}
      </Card.Body>
    </Card>
  );
};
